<div class="sidenavbar md-sidenav-right md-whiteframe-z2 summary_cart cart-no-overflow ng-isolate-scope _md"
  [ngClass]="{'show ds-summary-cart': sideNavBarService.showsideBarSummary}">
  <div mat-component-id="summaryCart" open="isSidenavOpen" tabindex="-1" class="fx-col">
    <div class="md-menu-toolbar _md _md-toolbar-transitions orderSummary fx-flex-100-in-col">
      <div class="layout-align-start-stretch layout-column fx-col fx-main-start fx-cross-stretch">
        <div class="layout-row fx-row" style="padding-bottom: 10px;">
          <span class="flex fx-flex"></span>
          <button mat-icon-button (click)="sideNavBarService.triggerOpen()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="ordersumary_heading fx-row">
          <div class="fx-col fx-main-start fx-cross-stretch fx-flex-50">
            @if (!utilityService.getAutoshipEditFlag()) {
              <p class="line_height_1 f-s-18" translate="order_summary"></p>
            }
            @if (utilityService.getAutoshipEditFlag()) {
              <span ng-bind="getAutoshipNumber()"></span>
            }
            @if (itemsService.selectedOrderItems.length>0) {
              <p class="pV"><span translate="global_total"></span>
              @if (itemsService.selectedOrderItems.length>0) {
                <span
                [textContent]="': (' + getOrderQuanity()+ ' items)'"></span>
              }
              @if (utilityService.getAutoshipEditFlag() && itemsService.selectedOrderItems.length == 0) {
                <span
                [textContent]="': (' + getAutoOrderQuanity()+ ' items)'"></span>
              }
            </p>
          }
          @if ((this.itemsService.selectedPacks == 0)) {
            <p
              class="pV m-t-20" style="width: 309px !important;"><span>Your cart is currently empty. Keep
            Shopping.</span>
          </p>
        }
      </div>
      <div class="md-secondary-container fx-row fx-main-end fx-cross-stretch fx-flex-50">
        <div class="width-100 text-right">
          @if (itemsService.selectedOrderItems.length>0) {
            <p class="main_price"
              [textContent]="((orderService.calculateOrderResponse.Total) ? (orderService.calculateOrderResponse.Total) : 0) | currency:companyService.selectedCurrency.CurrencyCode">
            </p>
          }
          @if (utilityService.getAutoshipEditFlag() && itemsService.selectedOrderItems.length == 0) {
            <p class="main_price"
              [textContent]="((orderService.calculateAutoOrderResponse.Total) ? (orderService.calculateAutoOrderResponse.Total) : 0) | currency:companyService.selectedCurrency.CurrencyCode">
            </p>
          }

          @if (itemsService.selectedOrderItems.length>0) {
            <p class="f-right c-light main_qv">
              {{'global_pv'|translate}}
              @if (itemsService.selectedOrderItems.length>0) {
                <span>:
                {{((orderService.orderBusinessVolume) || 0)}}</span>
              }
              @if (utilityService.getAutoshipEditFlag() && itemsService.selectedOrderItems.length==0) {
                <span>:
                {{((orderService.orderBusinessVolume) || 0)}}</span>
              }
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-content class="mat-content md_cart _md fx-row fx-flex-100-in-col">
  <mat-list role="list" class="fx-flex-100">
    <mat-accordion [togglePosition]="'before'" multi>
      @if (itemsService.selectedPacks.length > 0 && utilityService.isEnrollment()) {
        <mat-expansion-panel>
          <mat-expansion-panel-header class="md-no-sticky list-item-head md-subheader _md p-t-10 fx-row-in-expansion-header">
            <div class="fx-flex-100" role="heading" tabindex="0" aria-level="2">
              <div class="md-subheader-inner fx-row">
                <div class="md-subheader-content fx-row fx-flex-100">
                  <div class="initOrder fx-col fx-flex-60">
                    <h3 translate="shop_kit_order"></h3>
                    <p class="enroll_main_total pV">
                      <span translate="sub_total" class="pV"></span><span
                    [textContent]="': (' + getPacksQuanity()+ ' items)'"></span>
                  </p>
                </div>
                <div class="fx-col fx-flex-40">
                  <p class="price_each fx-row fx-main-end fx-cross-center"
                    [textContent]="orderService.packTotal | currency: companyService.selectedCurrency.CurrencyCode">
                  </p>
                  <p class="pV fx-row fx-main-end fx-cross-center">{{'global_pv'|translate}} <span
                  [textContent]="' : ' + (orderService.packBusinessVolume || 0)"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="in collapse fx-col" aria-expanded="true" aria-hidden="false">
        @for (item of getItems('pack'); track item; let i = $index) {
          <div
            class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
            <div class="cart-items__images fx-flex-30">
              <img [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                [default]="'assets/images/noimage.png'" class="img-avatar">
              </div>
              <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-53">
                <h3 class="product_detail_text color-header" [textContent]="item.ProductName | slice:0:40"></h3>
                @if (item.selectedOptions) {
                  <span class="f-s-12" [textContent]="item.selectedOptions"></span>
                }
                <p class="product_detail_qv" [ngClass]="item.selectedOptions? 'm-b-0' : 'm-b-0'">
                  {{'global_pv'|translate}}<span> : {{item.Quantity * (item.CV || item.QV || 0)}}</span></p>
                  @if (false) {
                    <div class="input-group fx-row fx-main-center fx-cross-center">
                      <span class="input-group-btn">
                        <button mat-button-icon class="" (click)="decreaseQuantiy('pack', item);closeCart();"
                          type="button">
                        <mat-icon class="">remove</mat-icon>
                      </button>
                    </span>
                    <input type="text" [(ngModel)]="getQuantityModel('pack', item)[item.ItemID]"
                      (change)="checkQuantity('pack', item); closeCart()"
                      (keyup)="($event.which === 38) ? increaseQuantiy('pack', item) : 0"
                      (keydown)="($event.which === 40) ? decreaseQuantiy('pack', item) : 0 ; closeCart()"
                      (keypress)="getLastQuantity('pack', item)"
                      (ngInit)="getQuantityModel('pack', item)[item.ItemID] ? getQuantityModel('pack', item)[item.ItemID] : getQuantityModel('pack', item)[item.ItemID] = 1"
                      class="input-control" maxlength="2" validate="" inputonlynumber="true" aria-invalid="false">
                    <span class="input-group-btn">
                      <button mat-button-icon (click)="increaseQuantiy('pack', item)" type="button">
                        <mat-icon>add</mat-icon>
                      </button>
                    </span>
                  </div>
                }
              </div>
              <div class="fx-flex-17">
                @if (false) {
                  <button mat-icon-button (click)="removeFromCart('pack', item);closeCart();">
                    <mat-icon class="">close</mat-icon>
                  </button>
                }
                <div class="md-secondary-container">
                  <div class="price_set">
                    <p class=""
                      [textContent]="(item.Quantity * item.Price) | currency: companyService.selectedCurrency.CurrencyCode">
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
    @if (itemsService.selectedOrderItems.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header class="md-no-sticky list-item-head md-subheader _md p-t-10 panel1 fx-row-in-expansion-header">
          <div class="fx-flex-100" role="heading" tabindex="0" aria-level="2">
            <div class="md-subheader-inner fx-row">
              <div class="md-subheader-content fx-row fx-flex-100">
                <div class="initOrder fx-col fx-flex-60">
                  <h3 translate="initial_order"></h3>
                  <p class="enroll_main_total pV">
                    <span translate="sub_total"></span>
                    <span [textContent]="': (' + getOrderQuanity()+ ' items)'"></span>
                  </p>
                </div>
                <div class="pV fx-col fx-flex-40">
                  <p class="price_each fx-row fx-main-end fx-cross-center"
                    [textContent]="(orderService.orderTotal ? orderService.orderTotal : 0) | currency: companyService.selectedCurrency.CurrencyCode">
                  </p>
                  <p class="pV fx-row fx-main-end fx-cross-center">{{'global_pv'|translate}}
                    <span [textContent]="' : ' + (orderService.orderBusinessVolume || 0)"></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel-header>
        <div aria-expanded="true" aria-hidden="false" class="fx-col">
          @for (item of getItems('order'); track item) {
            <div
              class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
              <div class="cart-items__images fx-flex-30">
                <img class="img-avatar"
                  [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
                  [default]="'assets/images/noimage.png'">
                </div>
                <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-53">
                  <h3 class="product_detail_text color-header" [textContent]="item.ProductName | slice:0:40"
                  [matTooltip]="item.ProductName"></h3>
                  @if (item.selectedOptions) {
                    <span class="f-s-12" [textContent]="item.selectedOptions"></span>
                  }
                  <p class="product_detail_qv  m-b-0">{{'global_pv'|translate}}<span> : {{item.Quantity * (item.CV ||
                  item.QV || 0)}}</span></p>
                  <div class="input-group fx-row fx-main-center fx-cross-center">
                    <span class="input-group-btn">
                      <button mat-button-icon class="" (click)="decreaseQuantiy('order', item);closeCart()"
                        type="button">
                      <mat-icon class="">remove</mat-icon>
                    </button>
                  </span>
                  <input type="text" [(ngModel)]="getQuantityModel('order', item)[item.ItemID]"
                    (change)="checkQuantity('order', item); closeCart()"
                    (keyup)="($event.which === 38) ? increaseQuantiy('order', item) : 0"
                    (keydown)="($event.which === 40) ? decreaseQuantiy('order', item) : 0 ; closeCart()"
                    (keypress)="getLastQuantity('order', item)"
                    (ngInit)="getQuantityModel('order', item)[item.ItemID] ? getQuantityModel('order', item)[item.ItemID] : getQuantityModel('order', item)[item.ItemID] = 1"
                    class="input-control" validate inputonlynumber="true" maxlength="2" aria-invalid="false">
                  <span class="input-group-btn">
                    <button mat-button-icon (click)="increaseQuantiy('order', item)" type="button">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
              <div class="fx-flex-17">
                <button mat-icon-button (click)="removeFromCart('order', item);closeCart();">
                  <mat-icon class="">close</mat-icon>
                </button>
                <div class="md-secondary-container">
                  <div class="price_set">
                    <p class=""
                      [textContent]="(item.Quantity * item.Price) | currency: companyService.selectedCurrency.CurrencyCode">
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
    @if (itemsService.selectedOrderItems.length > 0 || itemsService.selectedPacks.length > 0) {
      <div class="items total md-no-proxy _md flex fx-row" flex="" role="listitem"
        >
        <div class="summary_total m-t-5 fx-col fx-flex">
          <div class="fx-row fx-flex-100-in-col">
            <div class="total_block f-s-16 c-1 fx-flex-50" translate="sub_total"></div>
            <div class="total_block f-s-16 c-1 fx-row fx-main-end fx-cross-center fx-flex-50"
              [textContent]="((orderService.calculateOrderResponse.SubTotal) ? (orderService.calculateOrderResponse.SubTotal) : 0) | currency: companyService.selectedCurrency.CurrencyCode">
            </div>
          </div>
          <div class="fx-row fx-flex-100-in-col">
            <div class="total_block f-s-14 c-1 fx-flex-50" translate="discounttotal"></div>
            <div class="total_block f-s-14 c-1 fx-row fx-main-end fx-cross-center fx-flex-50"
              [textContent]="((orderService.calculateOrderResponse.DiscountTotal) ? (orderService.calculateOrderResponse.DiscountTotal) : 0) |currency:companyService.selectedCurrency.CurrencyCode">
            </div>
          </div>
          <!-- <div fxLayout="row" fxFlex="100">
          <div fxFlex="50" class="total_block f-s-16 c-1" translate="shippingtotal"></div>
          <div fxFlex="50" class="total_block f-s-16 c-1" fxLayoutAlign="end center" [textContent]="((orderService.calculateOrderResponse.ShippingTotal) ? (orderService.calculateOrderResponse.ShippingTotal) : 0) |currency:companyService.selectedCurrency.CurrencyCode"></div>
        </div> -->
        <div class="fx-row fx-flex-100-in-col">
          <div class="total_block f-s-16 c-1 fx-flex-50" translate="taxtotal"></div>
          <div class="total_block f-s-16 c-1 fx-row fx-main-end fx-cross-center fx-flex-50"
            [textContent]="((orderService.calculateOrderResponse.TaxTotal) ? (orderService.calculateOrderResponse.TaxTotal) : 0) |currency:companyService.selectedCurrency.CurrencyCode">
          </div>
        </div>
        <div class="fx-row fx-flex-100-in-col">
          <div class="total_block f-s-16 c-1 fx-flex-50" translate="global_total"></div>
          <div class="total_block f-s-16 c-1 fx-row fx-main-end fx-cross-center fx-flex-50"
            [textContent]="((orderService.calculateOrderResponse.Total) ? (orderService.calculateOrderResponse.Total) : 0) |currency:companyService.selectedCurrency.CurrencyCode">
          </div>
        </div>
      </div>
      <div class="md-secondary-container"></div>
    </div>
  }
  @if (itemsService.selectedAutoOrderItems.length > 0) {
    <mat-expansion-panel>
      <mat-expansion-panel-header class="md-no-sticky list-item-head md-subheader _md p-t-10 panel2">
        <mat-panel-description class="fx-row">
          <div class="fx-col fx-flex-100" (click)="$event.stopPropagation();">
            <div class="fx-flex-100-in-col" role="heading" tabindex="0" aria-level="2">
              <div class="md-subheader-inner fx-row">
                <div class="md-subheader-content p-r-0 fx-row fx-flex-100">
                  <div role="button" tabindex="0" class="fx-col fx-flex-100">
                    <div role="listitem" class="autoShipOrder fx-row fx-flex-100-in-col">
                      <div class="autoShipH3 fx-col fx-flex-60">
                        <h3 translate="Autoship Order"></h3>
                        <p class="subTotal">
                          <span translate="sub_total"></span><span
                        [textContent]="': (' + getAutoOrderQuanity() + ' items)'"></span>
                      </p>
                    </div>
                    <div class="total-coloumn fx-col fx-flex-40">
                      <h3 class="line_height_1 fx-row fx-main-end fx-cross-center"
                        [textContent]="(orderService.calculateAutoOrderResponse.SubTotal ? (orderService.calculateAutoOrderResponse.SubTotal - orderService.calculateAutoOrderResponse.DiscountTotal) : 0) | currency:companyService.selectedCurrency.CurrencyCode">
                      </h3>
                      <p class="f-right fx-row fx-main-end fx-cross-center">{{'global_pv'|translate}}<span> :
                      {{(orderService.autoorderBusinessVolume || 0)}}</span></p>
                    </div>
                    <div class="md-secondary-container"></div>
                  </div>
                  <div class="fx-flex-100-in-col">
                    <p class="subTotal">Your next order will process
                      {{commonData.FrequencyTypes[persistentService.retailData.Autoship.FrequencyTypeID].Description
                    }}, starting on:</p>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <div class="fx-row fx-main-start fx-cross-center fx-flex-30">
                      <mat-icon style="margin-bottom: 18px; cursor: pointer;"
                      (click)="dp3.open()">calendar_today</mat-icon>
                    </div>
                    <div class="fx-flex-60">
                      <mat-form-field class="example-full-width">
                        <input matInput [(ngModel)]="autoshipConfigurationService.autoshipDate"
                          [min]="AutoshipMinDate" [max]="AutoshipMaxDate" [matDatepicker]="dp3" disabled>
                        <mat-datepicker-toggle matPrefix [for]="dp3">
                          <mat-icon class="c-gray" matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #dp3 disabled="false"
                        [startAt]="autoshipConfigurationService.autoshipDate"></mat-datepicker>
                      </mat-form-field>
                      <p class="autoShipFreq" style="line-height: 0; text-align: left; font-size: 11px;"
                      [translate]="'choose_frequency'" for="freq_dd">Choose Autoship Frequency</p>
                    </div>
                    <div class="fx-flex-10">
                    </div>
                  </div>
                  <div class="fx-row fx-flex-100-in-col">
                    <div class="m-t-15 m-r-5 fx-flex-30">
                      <span style="word-break: break-all;" translate="frequency"></span>
                    </div>
                    <div class="fx-flex-70">
                      <mat-form-field md-no-float=""
                        class="md-block m-0 ds-validate control-group height-auto fieldBox__input-container md-input-has-value flex-gt-sm"
                        flex-gt-sm="">
                        <mat-select [(ngModel)]="persistentService.retailData.Autoship.FrequencyTypeID"
                          (selectionChange)="setFrequency();">
                          @for (freq of commonData.FrequencyTypes; track freq) {
                            <mat-option [value]="freq.ID">
                              {{freq.Description | translate}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div aria-expanded="true" aria-hidden="false" class="fx-col">
      @for (item of getItems('autoship'); track item) {
        <div
          class="items m-t-5 md-no-proxy md-with-secondary _md fx-row fx-flex-100-in-col">
          <div class="cart-items__images fx-flex-30">
            <img [src]="configService.localSettings.Disco.DiscoUrl+ '/CMS/images/inventory' + getImage(item)"
              [default]="'assets/images/noimage.png'" class="img-avatar">
            </div>
            <div class="md-list-item-text layout-column p-t-8 fx-col fx-flex-53">
              <h3 class="product_detail_text color-header" [textContent]="item.ProductName | slice:0:40"
              [matTooltip]="item.ProductName"></h3>
              @if (item.selectedOptions) {
                <span class="f-s-12" [textContent]="item.selectedOptions"></span>
              }
              <p class="product_detail_qv  m-b-0">{{'global_pv'|translate}}<span> :
              {{item.Quantity * (item.CV || item.QV || 0)}}</span></p>
              <div class="input-group fx-row fx-main-center fx-cross-center">
                <span class="input-group-btn">
                  <button mat-button-icon class="" (click)="decreaseQuantiy('autoship', item);closeCart();"
                    type="button">
                  <mat-icon>remove</mat-icon>
                </button>
              </span>
              <input type="text" [(ngModel)]="getQuantityModel('autoship',item)[item.ItemID]"
                (change)="checkQuantity('autoship', item); closeCart()"
                (keyup)="($event.which === 38) ? increaseQuantiy('autoship', item) : 0"
                (keydown)="($event.which === 40) ? decreaseQuantiy('autoship', item) : 0 ; closeCart()"
                (keypress)="getLastQuantity('autoship', item)"
                (ngInit)="getQuantityModel('autoship', item)[item.ItemID] ? getQuantityModel('autoship', item)[item.ItemID] : getQuantityModel('autoship', item)[item.ItemID] = 1"
                class="input-control" maxlength="2" validate="" inputonlynumber="true" aria-invalid="false">
              <span class="input-group-btn">
                <button mat-button-icon class="" (click)="increaseQuantiy('autoship', item)" type="button">
                  <mat-icon>add</mat-icon>
                </button>
              </span>
            </div>
          </div>
          <div class="fx-flex-17">
            <button mat-icon-button (click)="removeFromCart('autoship', item);closeCart();">
              <mat-icon class="">close</mat-icon>
            </button>
            <div class="md-secondary-container">
              <div class="price_set">
                <p class=""
                  [textContent]="(item.Quantity * item.Price) | currency: companyService.selectedCurrency.CurrencyCode">
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </mat-expansion-panel>
}
</mat-accordion>

<!-- For Edit Autoship button -->
@if ((utilityService.getAutoshipEditFlag() && itemsService.selectedAutoOrderItems.length > 0) && (itemsService.selectedOrderItems.length>0)) {
  <div class="p-t-10 p-b-10 fx-col fx-main-center fx-cross-center"
    >
    @if (!( location.path().toLowerCase() == '/manageautoship') || ( location.path().toLowerCase() == '/checkout') || ( location.path().toLowerCase() == '/application'|| location.path().toLowerCase() == '/login')) {
      <button mat-button class="logButton text-uppercase fx-row fx-main-center fx-cross-center"
      (click)="saveEditAutoship()">{{'save_and_continue' | translate}}</button>
    }
    @if (!(location.path().toLowerCase() == '/manageautoship') || (location.path().toLowerCase() == '/checkout') || ( location.path().toLowerCase() == '/application'|| location.path().toLowerCase() == '/login')) {
      <button mat-button class="logButton text-uppercase m-t-10 fx-row fx-main-center fx-cross-center"
      (click)="NavigateToAutoship()">{{'cancel' | translate}}</button>
    }
  </div>
}
@if ((!utilityService.getAutoshipEditFlag() && !((location.path().toLowerCase() == '/checkout') && !userService.customerData.CustomerId )) && (itemsService.selectedOrderItems.length>0 || this.itemsService.selectedAutoOrderItems.length>0)) {
  <div amit class="p-t-10 p-b-10 fx-col fx-main-center fx-cross-center"
    >
    @if (showLogincheckoutBtn()) {
      <button mat-button class="logButton text-uppercase fx-row fx-main-center fx-cross-center"
        (click)="navigateToApplication();">{{(isLoggedIn() ? 'check_out' :
      'login&checkout') | translate}}</button>
    }
    @if (showNewCustomerBtn() && !(location.path().toLowerCase() == '/login')) {
      <p class="p-t-10 p-b-10">Or</p>
    }
    @if (showNewCustomerBtn()) {
      <button mat-button class="checkOUTNewButton text-uppercase fx-row fx-main-center fx-cross-center"
        validate trigger-checksection="true"
      (click)="goToSignUp()">{{'create_new_customer_type' | translate: getCustomerTypeName()}}</button>
    }
    @if (location.path().toLowerCase() == '/checkout') {
      <button mat-button class="logButton text-uppercase fx-row fx-main-center fx-cross-center" [ngClass]="{'disabled': !canCheckOut()}"
      (click)="navigateToNextStep()">{{'place_order_' | translate}}</button>
    }
  </div>
}
</mat-list>
</div>
<div style="height: 20px;">
</div>
</div>
</div>